import type { Segment, SegmentedChoicesData } from '../../types';

export interface SegmentData {
  id: SegmentedChoicesData['id'];
  [key: string]: number;
}

export const getSegmentData = (
  data: SegmentedChoicesData[],
  segments: Segment[],
  segmentKeyAccessor: (d: Segment) => number,
) => {
  return data.map(({ id, scores }) => {
    const scoresObject: SegmentData = { id };
    segments.forEach((segment) => {
      // we should maybe use segment id instead of position
      // however, we can't do that because segment id is typed as `number | null`
      // until we have a better promise from BE, it's safer to use position and it has to be unique anyway
      scoresObject[String(segmentKeyAccessor(segment))] =
        scores[segmentKeyAccessor(segment)] || 0;
    });

    return scoresObject;
  });
};
